const trimTrailingSlash = (value: string | undefined) => (value ?? '').replace(/\/$/, '')

const TURNSTILE_TEST_SITE_KEY = '1x00000000000000000000AA'
const TURNSTILE_PRODUCTION_SITE_KEY = '0x4AAAAAAEM4TcCDCvBok2au'

export const env = Object.freeze({
  apiBaseUrl: trimTrailingSlash(import.meta.env.VITE_API_URL || '/webapi'),
  turnstileSiteKey:
    import.meta.env.VITE_TURNSTILE_SITE_KEY ||
    (import.meta.env.DEV ? TURNSTILE_TEST_SITE_KEY : TURNSTILE_PRODUCTION_SITE_KEY),
  mode: import.meta.env.MODE,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
})
